import { ErrorHandler, Injectable } from '@angular/core';
import { init, captureException, browserTracingIntegration } from '@sentry/angular';
import { FullStory } from '@fullstory/browser';
import { fullStoryIntegration } from '@sentry/fullstory';

import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from '../environments/environment';
import { versions } from '../environments/versions';

init({
  dsn: `${environment.sentryKey}`,
  environment: environment.production ? 'production' : 'staging',
  release: versions.version,
  denyUrls: [/.*0\.0\.0\.*/, /.*localhost.*/, /.*127\.0\.0\.1.*/],
  integrations: [
    browserTracingIntegration(),
    fullStoryIntegration(environment.sentryOrganisationSlug, { client: FullStory }),
  ],
  tracePropagationTargets: ['localhost', `/^${environment.serverURL}/`],
  tracesSampleRate: 0.25,
});

@UntilDestroy()
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (error.status !== 401) {
      captureException(error.originalError || error);
      console.error(error);
    }
    // Enable below once we have a better understanding of what
    // Errors to ask user for.
    // Sentry.showReportDialog({ eventId });
  }
}
